import { makeUseFetchOne } from '@elentari/core/hooks/makeUseFetchOne'
import { CandidatoDetail } from '../types'
import { repository } from './candidatoRepository'

export const useCandidato = makeUseFetchOne<CandidatoDetail, string>(
  {
    fetch: repository.fetchOne
  }
)
